import SideBar from "./SideBar";
import { Outlet } from "react-router-dom";

const LayoutConSidebar = () => {
  return (
    <div className="d-flex flex-column flex-md-row">
      <SideBar />
      <div className="flex-grow-1 p-3">
        <Outlet />
      </div>
    </div>
  );
};

export default LayoutConSidebar;
